import React from 'react';
const BlackOverlay = ({ bi }) => {
    return (
        <div style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(0, 0, 0, 0.50)', zIndex: 0 }} />
    );
}

export default BlackOverlay;
//